// Configuration de l'API centralisée
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.quizvs.com';

// URL de l'API de traduction (si différente)
export const TRANSLATE_API_URL = process.env.REACT_APP_TRANSLATE_URL || API_URL;

// Configuration par défaut pour les appels API
export const API_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
  },
};

// Helper pour construire des URLs d'API
export const buildApiUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};

// Helper pour les appels API avec authentification
export const fetchWithAuth = async (url: string, options: RequestInit = {}, token?: string) => {
  const config = {
    ...API_CONFIG,
    ...options,
    headers: {
      ...API_CONFIG.headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  };

  return fetch(url, config);
};
